export default function IconA1() {
    return (
        <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1272_65115)">
                <path d="M7.7625 14L4.875 21H24.125L21.2375 14H7.7625Z" stroke="black" strokeWidth="1.05" strokeLinejoin="round" />
                <path d="M6.625 5.25L7.86457 14" stroke="black" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22.375 5.25L21.1354 14" stroke="black" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14.5 3.5V14" stroke="black" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M4.875 21V22.75C4.875 23.2332 5.26675 23.625 5.75 23.625H23.25C23.7332 23.625 24.125 23.2332 24.125 22.75V21"
                    stroke="black"
                    strokeWidth="1.05"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1272_65115">
                    <rect width="28" height="28" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
